/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { List, useModalForm } from "@refinedev/antd";
import {
  BaseRecord,
  IResourceComponentsProps,
  useNotification,
} from "@refinedev/core";
import { Table } from "antd";
import { ColumnType } from "antd/es/table";
import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useModalForm as useModalFormAntd } from "sunflower-antd";
import { useCreateWallet, useGetListProviderWallet } from "../../api/wallet";
import { NewWalletModalCreate } from "../../components/modal/admin/addWallet";
import { EditWalletModal } from "../../components/modal/admin/editWallet";
import { useDeleteBank } from "../../utils/hooks/useDeleteBank.hook";
import { useIsAdminRole } from "../../utils/hooks/useIdentityAdmin.hook";
import { ButtonListHeader } from "../components/buttonsList";
import { Row } from "../components/interface";
import { TableForm } from "../crypto-withdrawal/tableForm";
import "../styles/index.css";

const start = 0;
const end = 10;

export const WalletsList: React.FC<IResourceComponentsProps> = () => {
  const { open: openNotificationWallet } = useNotification();
  const navigate = useNavigate();
  const [editingId, setEditingId] = useState<number>();
  const [deletingId, setDeletingId] = useState<number>();
  const queryParams = new URLSearchParams(location.search);
  const current = queryParams.get("current");
  const pageSize = queryParams.get("pageSize");
  const [currentPage, setCurrentPage] = useState(current ? Number(current) : 1);
  const [params, setParams] = useState({
    start: current ? (Number(current) - 1) * Number(pageSize) : start,
    end: pageSize ? Number(current) * Number(pageSize) : end,
  });
  // const {
  //   tableProps,
  //   searchFormProps,
  //   filters,
  //   tableQueryResult: { data: dataList, refetch: refetchList },
  // } = useTable<Row>({
  //   syncWithLocation: true,
  //   pagination: {
  //     pageSize: 10,
  //   },
  //   onSearch,
  // });

  const {
    data = {
      data: {
        data: { items: [], total: 0, totalPages: 0, pageSize: 0, page: 0 },
      },
    },
    isLoading: loadingGetList,
    refetch: refetchProviderWallet,
  } = useGetListProviderWallet({
    ...params,
  });

  const isAdminRole = useIsAdminRole();

  const handlePageChange = (page: number) => {
    navigate(`/wallets?pageSize=10&current=${page}`);
    setCurrentPage(page);
    setParams({
      start: (page - 1) * data?.data?.data?.pageSize || start,
      end: page * data?.data?.data?.pageSize || end,
    });
  };

  const {
    modalProps: createWalletModalProps,
    formProps: createWalletFormProps,
    show: createWalletModalShow,
    close: createWalletModalClose,
  } = useModalForm({
    warnWhenUnsavedChanges: false,
    action: "create",
  });

  const {
    close: editModalClose,
    modalProps: editModalProps,
    formProps: editFormProps,
    show: editModalShow,
  } = useModalFormAntd({});

  const { mutate: createWallet, isLoading: isLoadingCreate } = useCreateWallet({
    onSuccess: (response: { data: { message: string } }) => {
      if (openNotificationWallet) {
        openNotificationWallet?.({
          key: "success_transaction_confirm",
          message: response.data.message || "Add wallet successfully!",
          type: "success",
        });
      }
      refetchProviderWallet();
      createWalletModalClose();
      createWalletFormProps?.form?.resetFields();
    },
    onError: (error: { message: string }) => {
      if (openNotificationWallet) {
        openNotificationWallet({
          key: "add_wallet_failure",
          message: error?.message || "Add wallet failed!",
          type: "error",
        });
      }
    },
  });

  const handleClickOnCell = (record: BaseRecord) => {
    return {
      onClick: () => {
        if (record.id && isAdminRole) {
          setEditingId(Number(record.id));
        }
      },
    };
  };

  const { deleteBank } = useDeleteBank();

  // const onOkDelete = useCallback(async () => {
  //   if (deletingId !== undefined) {
  //     setDeletingId(undefined);
  //     await deleteBank(deletingId);
  //     // refetchList();
  //   }
  // }, [deleteBank, deletingId, refetchList]);

  const onCancelDelete = useCallback(
    () => setDeletingId(undefined),
    [setDeletingId]
  );

  // const { openNotification, contextHolder } = useNotificationOkCancel({
  //   ...confirmModalDeleteProps,
  //   onOk: onOkDelete,
  //   onCancel: onCancelDelete,
  // });

  // useEffect(() => {
  //   if (deletingId !== undefined) {
  //     openNotification();
  //   }
  // }, [deletingId, openNotification]);

  const columns: ColumnType<Row>[] = [
    {
      dataIndex: "id",
      title: "NO.",
      onCell: handleClickOnCell,
    },
    {
      dataIndex: "name",
      title: "Name",
      onCell: handleClickOnCell,
    },
    {
      dataIndex: "network",
      title: "Network",
      onCell: handleClickOnCell,
      render: (_value: string, record: BaseRecord) => (
        <span>{record?.network?.name}</span>
      ),
    },
    {
      dataIndex: "currency",
      title: "Currency",
      onCell: handleClickOnCell,
      render: (_value: string, record: BaseRecord) => (
        <span>{record?.assetConfigGroup?.symbol}</span>
      ),
    },

    {
      dataIndex: "address",
      title: "Addeess",
      onCell: handleClickOnCell,
    },
    {
      dataIndex: "company",
      title: "Company",
      onCell: handleClickOnCell,
      render: (_value: string, record: BaseRecord) => (
        <span>{record?.company?.fullName || record?.company?.name}</span>
      ),
    },
    // {
    //   render: (value, data) => {
    //     return (
    //       isAdminRole && (
    //         <Button
    //           className={"list-button list-button--delete"}
    //           icon={<DeleteOutlined style={{ fontSize: "19px" }} />}
    //           size="small"
    //           onClick={() => setDeletingId(data.id)}
    //         />
    //       )
    //     );
    //   },
    // },
  ];

  return (
    <>
      <List
        title="Provider Wallet Directory"
        headerButtons={null}
      >
        <TableForm
          // {...searchFormProps}
          // initialValues={{
          //   searchValue: getDefaultFilter("", filters),
          // }}
          // onSubmit={searchFormProps.form?.submit}
          searchPlaceholder={"Search wallet by name"}
          showDateFilter={false}
          headerButtons={
            isAdminRole ? ButtonListHeader(createWalletModalShow) : null
          }
        />
        <Table
          // {...tableProps}
          loading={loadingGetList}
          rowKey="id"
          columns={columns}
          dataSource={data?.data?.data?.items}
          pagination={{
            current: currentPage,
            total: data?.data?.data?.total,
            pageSize: data?.data?.data?.pageSize,
            onChange: handlePageChange,
          }}
        />
      </List>
      {/* {contextHolder} */}
      <NewWalletModalCreate
        closeModal={createWalletModalClose}
        formProps={createWalletFormProps}
        modalProps={createWalletModalProps}
        formIsLoading={isLoadingCreate}
        formSubmit={createWallet}
      />
      <EditWalletModal
        editingId={editingId}
        changeEditingId={setEditingId}
        show={editModalShow}
        formProps={editFormProps}
        modalProps={editModalProps}
        refetchList={refetchProviderWallet}
        closeModal={editModalClose}
      />
    </>
  );
};
